export const SET_USER = "SET_USER";

export const setUserInfo = (item = {}) => ({
  type: SET_USER,
  data: item,
});
